module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "200px",
      "text-align": "center",
      "margin": "30px 0px"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com//images/NoGoods404.jpg",
      "alt": "此商品以下架或者不存在"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d865ef9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/notGood.vue
// module id = 1580
// module chunks = 1